import React from 'react';
import {findDOMNode} from 'react-dom';
import LoadingIndicator from './LoadingIndicator';

function topPosition(domElt) {
    if (!domElt) {
        return 0;
    }
    return domElt.offsetTop + topPosition(domElt.offsetParent);
}

export default class InfiniteScroll extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: false
        };
    }
    componentDidMount() {
        this.attachScrollListener();
    }
    componentDidUpdate() {
        if (this.state.loading || this.state.error) return;
        this.attachScrollListener();
    }
    componentWillUnmount() {
        this.detachScrollListener();
    }
    attachScrollListener() {
        if (!this.props.hasMore || this.state.loading || this.state.error) {
            return;
        }
        if (this.boundScrollListener == null) {
            this.boundScrollListener = this.scrollListener.bind(this);
        }
        window.addEventListener('scroll', this.boundScrollListener);
        window.addEventListener('resize', this.boundScrollListener);
        setTimeout(() => this.scrollListener(), 10);
    }
    detachScrollListener() {
        window.removeEventListener('scroll', this.boundScrollListener);
        window.removeEventListener('resize', this.boundScrollListener);
    }
    scrollListener() {

        const el = findDOMNode(this);
        const scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset :
            (document.documentElement || document.body.parentNode || document.body).
                scrollTop;

        if (topPosition(el) + el.offsetHeight - scrollTop - window.innerHeight < (this.props.threshold || 250)) {
            this.detachScrollListener();
            var promise = this.props.loadMore();
            if (!promise || typeof promise.then !== 'function') {
                throw new Error('loadMore must return a Promise!');
            }
            promise.then(() => {
                setTimeout(() => {
                    this.setState({
                        loading: false,
                        error: false
                    });
                }, 10);
            }, () => {
                setTimeout(() => this.setState({
                    loading: false,
                    error: true
                }), 10);
            });

            // What if promise has failed?
            // We can display 'retry' button I suppose - But that involves using
            // a state etc.
            if (!this.state.loading || this.state.error) {
                this.setState({
                    loading: true,
                    error: false
                });
            }
        }
    }
    render() {
        const { children } = this.props;
        return (
            <div>
                { children }
                {this.state.loading && <div style={{width: '100%', textAlign: 'center'}}><LoadingIndicator /></div>}
                {this.props.hasMore && !this.state.loading &&
                <div onClick={this.props.loadMore} className="btn btn-default">Load more</div>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/InfiniteScroll.js